import "core-js/stable";
import { subscribeUser, unsubscribeUser, isSubscribed } from './PushMessaging';
import * as popups from './popups';
import * as alerts from './alerts';
import * as calendar from './calendar';
// These libraries set up event handlers or otherwise have side effects when imported.
// It might be better to move these to having an init() function that is explicitly called.
import * as oembed from './oembed'; // eslint-disable-line no-unused-vars
import * as banners from './banners'; // eslint-disable-line no-unused-vars
import * as forms  from './forms'; // eslint-disable-line no-unused-vars
import { get_csrf }  from './csrf'; // eslint-disable-line no-unused-vars
import { errorHandler } from './errors';
import { content_processor } from './content';
document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
window.addEventListener("load", ContentLoaded);

/**** Global error logging *****/
window.addEventListener('error', errorHandler);

var html_classes = document.documentElement.classList;

html_classes.remove("no-js");
html_classes.add("js");

window.kms = window.kms || {};
window.kms.push = {"subscribeUser" : subscribeUser, "unsubscribeUser":unsubscribeUser, "isSubscribed": isSubscribed};

function elementExists(selectors){
    //For a list of selectors, return true if any match an element in the DOM
    return selectors.some(function(selector){
        return document.querySelector(selector);
    });
}

const lazyLoadOnDOMReady = [
    {condition: () => (document.querySelector('form[method="POST"]') && window.kms.recaptcha_v3_public_key), script:'recaptcha'},
    {condition: () => (elementExists(['[data-post-load="advert"]', "a.KMS-advert"])), script:'adverts'},
    {condition: () => (elementExists([".file-upload-tool", ".image-upload-tool", ".date-picker-tool"])), script:'form-widgets'},
];

const lazyLoadOnContentLoaded = [
    {condition: () => (window.kms_is_logged_in_console && window.kms_inline_edit), script:'editing/edit'},
]

function loadScripts(scriptConditions){
    scriptConditions.forEach(function(scriptCondition){
        if (scriptCondition.condition()) {
            import(/* webpackChunkName: "[request]" */ './'+scriptCondition.script).then(script =>{
                if (script.initialise)
                    script.initialise();
            });
        }
    });
}

function onDOMContentLoaded(){
    popups.runPopups();
    alerts.runAlerts();
    content_processor(document.documentElement);
    calendar.initialise();
    loadScripts(lazyLoadOnDOMReady);
}
function ContentLoaded(){
    loadScripts(lazyLoadOnContentLoaded);
}
